export const CloudUpload = (props) => {
  const { size = 48, onClick, verticalAlign, marginLeft, marginRight, top, color = 'currentColor', className = ' ' } = props;
  // Renders as a native <button> (real keyboard/mouse/touch support, no ARIA-role workaround
  // needed) when clickable; otherwise a plain <span>, since it's then purely decorative.
  const Wrapper = onClick ? 'button' : 'span';
  const wrapperStyle = onClick
    ? { marginLeft, marginRight, top, color, background: 'none', border: 'none', padding: 0, cursor: 'pointer' }
    : { marginLeft, marginRight, top, color };
  return (
    <Wrapper
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={`icon-wrap ${className}`}
      style={wrapperStyle}
    >
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='40 -18 432 432'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='22'
          d='M135 330H390A75 75 0 0 0 368 182A115 115 0 0 0 140 182A75 75 0 0 0 135 330Z'
        />
        <path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='22' d='M256 284V182M216 220l40-40 40 40' />
      </svg>
    </Wrapper>
  );
};
